import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=4c30259d&"
import script from "./MessageModal.vue?vue&type=script&lang=js&"
export * from "./MessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/gcg3.devserver6.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c30259d')) {
      api.createRecord('4c30259d', component.options)
    } else {
      api.reload('4c30259d', component.options)
    }
    module.hot.accept("./MessageModal.vue?vue&type=template&id=4c30259d&", function () {
      api.rerender('4c30259d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/MessageModal.vue"
export default component.exports